import { personalInfo } from './personal';

export const loaderConfig = {
  name: personalInfo.name,
  message: 'Chargement du portfolio...',
};
